<template>
<el-dialog :visible.sync="show" title="修改报单" width="600px">
  <div class="warning-tip">丢单订单只能修改一次！请仔细检查报单ID再上报！</div>
  <div class="content">
    <el-form ref="form" :model="form" label-width="120px" size="small">
      <!-- <el-form-item label="报单ID：" prop="calculationFormId" :rules="[{ required: true, message: '请填写报单ID', trigger: 'blur' }]">
        <el-input v-model="form.calculationFormId" placeholder="请填写报单ID"></el-input>
      </el-form-item> -->
      <el-form-item label="报单ID：" prop="productId" :rules="[{ required: true, message: '请填写报单ID', trigger: 'blur' }]">
        <el-input v-model="form.productId" placeholder="请填写报单ID"></el-input>
      </el-form-item>
      <el-form-item label="订单号：" prop="thirdOrderSn">
        <el-input
          type="textarea"
          disabled
          :rows="3"
          v-model="form.thirdOrderSn"></el-input>
      </el-form-item>
      <el-form-item label="订单件数：" prop="orderNumber">
        <el-input v-model="form.orderNumber" @input="orderNumberInput" placeholder="请填写订单件数"></el-input>
      </el-form-item>
      <el-form-item label="订单金额：" prop="orderAmount">
        <el-input v-model="form.orderAmount" placeholder="请填写订单金额"></el-input>
      </el-form-item>
      <el-form-item label="渠道备注：">
        <el-input v-model="form.qdRemark" placeholder="请填写渠道备注"></el-input>
      </el-form-item>
      <el-form-item label="订单截图：">
        <div class="upload-images-wrap">
          <div class="images">
            <ui-upload
              class="item"
              v-if="orderScreenshot.length < 3"
              fileType="image"
              style="display: inline-block;"
              maxTip="(最多3张)"
              @submit="uploadCallback" />
            <div class="item" v-for="(item, index) in orderScreenshot" :key="index">
              <el-image class="img" :src="item" :preview-src-list="orderScreenshot"></el-image>
              <i class="el-icon-circle-close close" @click="delImage(index)"></i>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>

  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button size="mini" type="primary" @click="handleSubmit">保存</el-button>
  </div>

  <!-- 二次确认弹框 -->
  <el-dialog v-if="showConfirmDialog" :visible.sync="showConfirmDialog" append-to-body title="提示" width="410px">
    <div class="content" style="color: #F56C6C; font-weight: 600;">
      丢单订单只能修改一次！请仔细检查报单ID再上报！
    </div>
    <div slot="footer">
      <el-button size="mini" @click="showConfirmDialog = false">取消</el-button>
      <el-button size="mini" type="primary" @click="confirmSubmit">确 定</el-button>
    </div>
  </el-dialog>
</el-dialog>
</template>

<script>
import { uploadImage } from '@/service/apis/common'
import { modifySupOrderReportByFormWeb } from '@/service/apis/order'
import { formatNumber } from '@/utils/util'

export default {
  name: 'EditReportDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      orderScreenshot: [],
      showConfirmDialog: false,
      form: {
        // calculationFormId: '',
        productId: '',
        thirdOrderSn: '',
        orderNumber: '',
        orderAmount: '',
        qdRemark: ''
      }
    }
  },
  created () {
    this.initForm()
  },
  methods: {
    initForm () {
      const r = this.row
      // this.form.calculationFormId = r.calculationFormId || ''
      this.form.productId = r.productId || ''
      this.form.thirdOrderSn = r.thirdOrderSn || ''
      this.form.orderNumber = r.orderNumber != null ? String(r.orderNumber) : ''
      this.form.orderAmount = r.orderAmount != null ? String(r.orderAmount) : ''
      this.form.qdRemark = r.qdRemark || ''
      if (r.orderScreenshot) {
        this.orderScreenshot = r.orderScreenshot.split(',').filter(Boolean)
      }
    },
    delImage (index) {
      this.orderScreenshot.splice(index, 1)
    },
    uploadCallback (file) {
      if (this.orderScreenshot.length >= 3) {
        this.$message.warning('最多上传3张图片')
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      const formData = new FormData()
      formData.append('media', file)
      uploadImage.call(this, formData).then(resp => {
        this.orderScreenshot.push(resp.img)
      }).finally(() => {
        loading.close()
      })
    },
    orderNumberInput (val) {
      this.$nextTick(() => {
        this.form.orderNumber = formatNumber(val, 0)
      })
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return false
        this.showConfirmDialog = true
      })
    },
    confirmSubmit () {
      const opt = {
        id: this.row.id,
        // calculationFormId: this.form.calculationFormId,
        productId: this.form.productId,
        thirdOrderSn: this.form.thirdOrderSn,
        orderNumber: this.form.orderNumber,
        orderAmount: this.form.orderAmount,
        qdRemark: this.form.qdRemark,
        orderScreenshot: this.orderScreenshot.join(',')
      }
      modifySupOrderReportByFormWeb.call(this, opt).then(res => {
        if (res !== undefined) {
          this.$message.success('修改成功')
          this.showConfirmDialog = false
          this.$emit('on-success')
        }
      })
    }
  }
}
</script>

<style scoped>
.warning-tip {
  color: #F56C6C;
  font-weight: 600;
  font-size: 14px;
  padding: 8px 12px;
  background: #FEF0F0;
  border-radius: 4px;
  margin-bottom: 8px;
}
.content {
  padding-top: 12px;
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
::v-deep .upload {
  width: 100px;
  height: 100px;
  font-size: 12px;
}
::v-deep .upload img {
  width: 60%;
  height: auto;
}
.upload-images-wrap {
  display: flex;
  align-items: top;
}
.images {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
.images .item {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  position: relative;
  margin-right: 6px;
  margin-bottom: 10px;
}
.images .item .close {
  position: absolute;
  right: -4px;
  top: -4px;
  cursor: pointer;
}
.images .item .img {
  width: 100%;
  height: 100%;
}
</style>
